templateHelpers = require './template-helpers'
Adams = require 'lib/adams'

module.exports = templateHelpers(Adams)



// WEBPACK FOOTER //
// ./app/scripts/views/internal/teacup-with-helpers.coffee